import { parsePhoneNumber } from 'awesome-phonenumber';

export const formatPhoneNumber = (phoneNumber: string | number | undefined, countryCode = 'US') => {
  if (!phoneNumber) {
    return '';
  }
  const pn = parsePhoneNumber(`${phoneNumber}`, { regionCode: countryCode });
  return pn.number?.national || '';
};
